import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Dynamically load locale files to avoid duplication with languageUtils.ts
const loadLocales = async () => {
  const localeModules = import.meta.glob('./locales/*.json');
  const resources: Record<string, { translation: Record<string, string> }> = {};

  for (const [path, loader] of Object.entries(localeModules)) {
    const match = path.match(/\/locales\/([^/]+)\.json$/);
    if (match) {
      const languageCode = match[1];
      const module = (await loader()) as { default: Record<string, string> };
      resources[languageCode] = {
        translation: module.default,
      };
    }
  }

  return resources;
};

// Initialize i18n with dynamically loaded resources
const initI18n = async () => {
  const resources = await loadLocales();

  void i18n.use(initReactI18next).init({
    resources,
    lng: 'en', // Default language - English
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    // Optional: Add debug mode for development
    debug: process.env.NODE_ENV === 'development',
  });
};

// Initialize immediately
void initI18n();

export default i18n;
